var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4229",
    "data-name": "Rectangle 4229",
    width: 26,
    height: 26,
    transform: "translate(614 477)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_12",
    "data-name": "Mask Group 12",
    transform: "translate(-614 -477)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archive-book-02",
    transform: "translate(614.75 477.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9916",
    "data-name": "Path 9916",
    d: "M16.174,2.708V9.1a.544.544,0,0,1-.91.4l-1.9-1.744a.537.537,0,0,0-.737,0l-1.9,1.733a.54.54,0,0,1-.91-.39V2.708a.536.536,0,0,1,.542-.542h5.265A.536.536,0,0,1,16.174,2.708Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9917",
    "data-name": "Path 9917",
    d: "M18.4,2.232a.543.543,0,0,0-.6.542V9.295a2.077,2.077,0,0,1-3.488,1.528l-.942-.867a.537.537,0,0,0-.737,0l-.942.867a2.079,2.079,0,0,1-2.243.379A2.087,2.087,0,0,1,8.2,9.295V2.773a.543.543,0,0,0-.6-.542C4.572,2.611,3.25,4.658,3.25,7.583V18.417c0,3.25,1.625,5.417,5.417,5.417h8.667c3.792,0,5.417-2.167,5.417-5.417V7.583C22.75,4.658,21.428,2.611,18.4,2.232Zm.563,18.081H9.75a.813.813,0,0,1,0-1.625h9.208a.813.813,0,0,1,0,1.625Zm0-4.333h-4.6a.813.813,0,0,1,0-1.625h4.6a.812.812,0,0,1,0,1.625Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsActive);
export default __webpack_public_path__ + "static/media/docs_active.095fe93f7c25243107f6884db346bdcd.svg";
export { ForwardRef as ReactComponent };